/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// @mui material components
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import { useTranslation } from "react-i18next";
import { APP_STATE } from "services/Define";
import { FetchData } from "services/Request";
import { useSelector } from "react-redux";
import * as Func from "services/Function";

const initAttr = {
  id: "",
  code: "",
  supplier_name: "",
  type_name: "",
  date_record: "",
  remark: "",
  user_name: "",
};

function ProductionFinishJob() {
  const mod = "production_finish";
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [attr, setAttr] = useState(initAttr);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const open = () => {
    setLoading(true);
    setAttr(initAttr);
    setList([]);

    FetchData("OPTIONS", `/${mod}/joborder`, app.token, {
      id: id,
      lang: app.lang,
    }).then((result) => {
      if (result.status === "ok") {
        setAttr(result.data);
        setList(result.list);

        setLoading(false);
      }
    });
  };

  const imageDisplay = (item) => {
    return <Avatar alt={item.name} src={item.image} variant="rounded" />;
  };

  const expireDisplay = (item) => {
    if (item.is_expire === "N") return "-";

    return Func.dateDisplay(item.date_expire);
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const renderInfo = () => {
    return (
      <Paper variant="outlined" sx={{ padding: 2, marginBottom: 2 }}>
        <MDTypography variant="h5" mb={3}>
          #{attr.code}
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDInput
              label="ผู้ควบคุม"
              value={attr.user_name}
              variant="standard"
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label="วันผลิต"
              value={Func.dateDisplay(attr.date_record)}
              variant="standard"
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label="หมายเหตุ"
              value={attr.remark}
              variant="standard"
              multiline
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </Paper>
    );
  };

  const renderOpen = () => {
    return (
      <MDBox mb={0}>
        <Grid container mb={3} spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={3}>
            {renderInfo()}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={9}>
            <MDBox sx={{ border: "1px solid #e2e2e2", borderRadius: 1 }}>
              <MDBox p={2}>
                <MDTypography variant="h5">{t(`element.order`)}</MDTypography>
              </MDBox>
              <TableContainer sx={{ boxShadow: 0 }}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">No.</TableCell>
                      <TableCell align="center">รูป</TableCell>
                      <TableCell>SKU</TableCell>
                      <TableCell>สินค้า</TableCell>
                      <TableCell align="right">จำนวน</TableCell>
                      <TableCell align="right">ผลิตเสร็จ</TableCell>
                      <TableCell align="right">รอผลิต</TableCell>
                      <TableCell>หน่วย</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {list.map((row, i) => (
                      <TableRow key={row.id}>
                        <TableCell align="center" width="100">
                          {i + 1}
                        </TableCell>
                        <TableCell width="40">{imageDisplay(row)}</TableCell>
                        <TableCell align="left">{row.sku}</TableCell>
                        <TableCell align="left">{row.product_name}</TableCell>
                        <TableCell align="right">{Func.numberDisplay(row.quantity)}</TableCell>
                        <TableCell align="right">
                          {Func.numberDisplay(row.quantity_receive)}
                        </TableCell>
                        <TableCell align="right">
                          {Func.numberDisplay(row.quantity_balance)}
                        </TableCell>
                        <TableCell align="left">{row.unit_name}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    open();
  }, [id]);

  return (
    <div>
      {renderOpen()}
      {renderLoading()}
    </div>
  );
}

export default ProductionFinishJob;
